import { useCallback, useEffect, useState } from "react";
import { useDialog } from "../../../Common/Dialog";
import { useLoading } from "../../hooks/form";
import actions from "../../../actions";
import { KYDOrganizationFull } from "@common/interfaces/KYDOrganization";

export const useOrganization = () => {
  const [organization, setOrganization] = useState<KYDOrganizationFull | null>(
    null
  );
  const [loading, setLoading] = useLoading<{ init: boolean }>({ init: false });
  const dialog = useDialog();

  const fetchOrganization = useCallback(
    async (options?: { silent?: boolean }) => {
      if (!options || (options && !options.silent)) {
        setLoading("init", true);
      }
      try {
        const org = await actions.ADMIN.fetchOrganization();
        setOrganization(org);
      } catch (err: any) {
        dialog({ text: err.message });
      }
      setLoading("init", false);
    },
    [setLoading, dialog]
  );

  useEffect(() => {
    setLoading("init", true);
    fetchOrganization().finally(() => {
      setLoading("init", false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    refetch: (options?: { silent?: boolean }) => fetchOrganization(options),
    organization,
    loading: loading.init as boolean,
  };
};
